import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import _ from 'lodash'
import {
  colorVars,
  colorLongToShort,
  getCssColorFromColorName,
  INHERIT,
} from '../../../utils/colors'
import Text from '../../elementals/text'
import cls from './styles.scss'

const COLOR_NAMES = _.keys(colorVars).map(colorLongToShort)
const COLOR_OPTIONS = COLOR_NAMES.concat(INHERIT, '')

const cx = classnames.bind(cls)

const SimpleCard = ({
  title,
  titleIcon = null,
  titleBackgroundColor,
  content,
  className,
  elmId,
}) => {
  const backgroundColor =
    titleBackgroundColor === INHERIT
      ? INHERIT
      : getCssColorFromColorName(titleBackgroundColor)

  return (
    <div className={cx('card', className)} data-elm-id={`${elmId}_body`}>
      <div
        className={cx('card-header')}
        style={{ background: backgroundColor }}
        data-elm-id={`${elmId}_title`}
      >
        <Text size='large' color='white' weight='heavy'>
          {title}
        </Text>
        {titleIcon}
      </div>
      <div className={cx('card-content')} data-elm-id={`${elmId}_content`}>
        {content}
      </div>
    </div>
  )
}

SimpleCard.propTypes = {
  title: PropTypes.string.isRequired,
  titleIcon: PropTypes.element,
  titleBackgroundColor: PropTypes.oneOf(COLOR_OPTIONS),
  content: PropTypes.node,
  className: PropTypes.string,
  elmId: PropTypes.string,
}

SimpleCard.defaultProps = {
  titleIcon: null,
  titleBackgroundColor: 'navyBlue',
  content: null,
  elmId: 'card',
}

export default SimpleCard
